import { Modal } from '@tryhackme/thm-ui-components';
import { SocialName } from 'src/common/page-share';
import { IS_BIG_STREAK_MILESTONE_DISMISSED } from 'src/features/header/constants';
import { ReactComponent as ImageThreeDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/3-streak-milestone.svg';
import { ReactComponent as ImageSevenDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/7-streak-milestone.svg';
import { ReactComponent as ImageThirtyDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/30-streak-milestone.svg';
import { ReactComponent as ImageNinetyDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/90-streak-milestone.svg';
import { ReactComponent as ImageOneHundredAndEightyDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/180-streak-milestone.svg';
import { ReactComponent as ImageThreeHundredAndSixtyFiveDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/365-streak-milestone.svg';
import { ReactComponent as ImageFiveHundredDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/500-streak-milestone.svg';
import { ReactComponent as ImageSevenHundredAndFiftyDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/750-streak-milestone.svg';
import { ReactComponent as ImageOneThousandDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/1000-streak-milestone.svg';
import { ReactComponent as ImageOneThousandTwoHundredAndFifityDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/1250-streak-milestone.svg';
import { ReactComponent as ImageOneThousandFiveHundredDaysStreakMilestone } from 'src/images/svgs/rooms/streak-milestone/1500-streak-milestone.svg';
import { streakMilestonesInDays } from '../streak-notification/streak-notification.constants';
import { StyledWrapperContent } from './big-streak-share-modal.styles';
import type { ShareRoomsCompletionModalProps } from './big-streak-share-modal.types';
import { BigStreakSocialSharing } from './components/big-streak-social-share';
export const BigStreakShareModal = ({
  streakLength,
  onOpenChange,
  isShareModalOpen,
  setIsShareModalOpen,
  isCompletionShareRoomModal,
  username,
  ...otherModalProps
}: ShareRoomsCompletionModalProps) => {
  const images = {
    3: <ImageThreeDaysStreakMilestone data-testid="3-days-streak-img" height={160} />,
    7: <ImageSevenDaysStreakMilestone data-testid="7-days-streak-img" height={160} />,
    30: <ImageThirtyDaysStreakMilestone data-testid="30-days-streak-img" height={160} />,
    90: <ImageNinetyDaysStreakMilestone data-testid="90-days-streak-img" height={160} />,
    180: <ImageOneHundredAndEightyDaysStreakMilestone data-testid="180-days-streak-img" height={160} />,
    365: <ImageThreeHundredAndSixtyFiveDaysStreakMilestone data-testid="365-days-streak-img" height={160} />,
    500: <ImageFiveHundredDaysStreakMilestone data-testid="500-days-streak-img" height={160} />,
    750: <ImageSevenHundredAndFiftyDaysStreakMilestone data-testid="750-days-streak-img" height={160} />,
    1000: <ImageOneThousandDaysStreakMilestone data-testid="1000-days-streak-img" height={160} />,
    1250: <ImageOneThousandTwoHundredAndFifityDaysStreakMilestone data-testid="1250-days-streak-img" height={160} />,
    1500: <ImageOneThousandFiveHundredDaysStreakMilestone data-testid="1500-days-streak-img" height={160} />
  };
  return <Modal {...otherModalProps} onOpenChange={onOpenChange} open={isShareModalOpen} data-sentry-element="Modal" data-sentry-component="BigStreakShareModal" data-sentry-source-file="big-streak-share-modal.tsx">
      <StyledWrapperContent data-sentry-element="StyledWrapperContent" data-sentry-source-file="big-streak-share-modal.tsx">
        {images[streakLength as keyof typeof images]}
        <h2>Amazing! You have hit a {streakLength} day streak!</h2>
        <p>
          You have been crushing it on TryHackMe for {streakLength} days. Come back tomorrow to keep your streak going!
        </p>
        <p>Show your network how consistent you have been!</p>
        <BigStreakSocialSharing username={username} streakLength={streakLength} socialLinks={{
        [SocialName.twitter]: true,
        [SocialName.facebook]: true,
        [SocialName.linkedin]: true
      }} data-sentry-element="BigStreakSocialSharing" data-sentry-source-file="big-streak-share-modal.tsx" />
      </StyledWrapperContent>
    </Modal>;
};
export const shouldShowBigStreakShareModal = (streakLength: number) => {
  const isBigStreak = streakMilestonesInDays.includes(streakLength);
  const isItDismissed = localStorage.getItem(`${IS_BIG_STREAK_MILESTONE_DISMISSED}_${streakLength}`) !== null;
  return isBigStreak && !isItDismissed;
};